export default "__VITE_ASSET__BQYLaXEq__"